module.exports = new __parcel__URL__("minus-mask.a30c8bf5.svg").toString();